import React, { useEffect, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import Input from "@/components/core/Input/Input"
import Button from "@/components/core/Button/Button"
import htmlParser from "html-react-parser"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import { addToCartItem } from "@/utils/addTocart"
import { addToCart } from "@/store/features/cartSlice"
import { showPreviewCart, showToast } from "@/store/features/genericSlice"
import { locationState } from "@/store/features/locationSlice"
import { getFindAStoresResult } from "@/components/FindStore/v1/api"
import _isEmpty from "lodash/isEmpty"
import {
  formatPhoneNumber,
  getShortenedUrl,
  isPromoAllowed,
} from "@/utils/helper"
import { isMobile } from "react-device-detect"
import { aemAxiosInstance } from "@/constants/api"
import { GLOBAL_CONFIGURATION_ENDPOINT } from "@/constants/index"
import {
  addAnalyticsForChangeZipCode,
  addAnalyticsForUpdate,
  addAnalyticsForBuymore,
  addAnalyticsForAddService,
  addAnalyticsForBathroomDesign,
  addAnalyticsForStoreNearYou,
  addAnalyticsForGetProfessionalClick,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/analytics"
import { getPincode } from "@/components/cart/cartHelper"

const ProductOnDisplay = ({
  pdpJson = {},
  productServices = {},
  installationData = {},
  currencyCode = "",
  currencySign = "$",
  brandName = "",
  findStores = "",
  colorsData = [],
  shortendPagePath = "",
  findStoreDetailsUrl = "",
  productType = "",
  productInfo = {},
  getZipCode = () => {},
}) => {
  const {
    locationTitles = "",
    zipCodeToUpdate = "",
    updateZipTitle = "",
    productDisplayTitle = "",
    sectionHeadingProductNotAvailable = "",
    addInstallServiceTitle = "",
    changeZipCode = "",
    yourZipCode = "",
    serviceUnavailableTitle = "",
    serviceUnavailableSectionHeading = "",
    descriptionProductNotAvailable = "",
    errorMessage = "",
    multiDesignServices = [],
    installServices = [],
    zipCodeTitle = "",
    buyMoreTitle = "",
    buyMoreToolTip = "",
    addServiceToCart = "",
  } = pdpJson

  const dispatch = useDispatch()
  const { utilityLocation = "" } = useSelector(locationState)

  const [tooltip, setTooltip] = useState({ buyMoreSaveMore: false })
  const [serviceDetails, setServiceDetails] = useState({})
  const [servicePrice, setServicePrice] = useState("")
  const [zipCodeInputVal, setZipCodeInputVal] = useState(utilityLocation)
  const [showAddanInstallCard, setShowAddanInstallCard] = useState(false)
  const [toggleZipCodeSection, setToggleZipCodeSection] = useState(
    zipCodeInputVal ? true : false
  )
  const [storeInfo, setStoreInfo] = useState([])
  const [findStoreUtilityDetails, setFindStoreUtilityDetails] = useState({})
  const learnMoreRef = useRef()
  const installSeriveRef = useRef()
  const isInitionalRender = useRef(true)
  const [zipcode, setZipcode] = useState()

  const installserviceClickHandler = (e, productInfo) => {
    const { target: { href = "", textContent = "" } = {} } = e
    addAnalyticsForBathroomDesign(textContent.toLowerCase(), href, productInfo)
    window.open(href)
  }

  const servicesClick = (e, productInfo) => {
    const { target: { href = "", textContent = "" } = {} } = e
    addAnalyticsForBuymore(textContent, href, productInfo)
    window.open(href)
  }

  const titleclickhandler = (e, productInfo) => {
    const { target: { href = "", textContent = "" } = {} } = e
    addAnalyticsForBuymore(textContent, href, productInfo)
    window.open(href)
  }

  useEffect(() => {
    if (showAddanInstallCard > 0) {
      if (installSeriveRef?.current) {
        installSeriveRef?.current?.querySelectorAll("a").forEach(item => {
          if (item?.getAttribute("listener") !== "true") {
            item?.addEventListener("click", e => {
              servicesClick(e, productInfo)
            })
          }
        })
      }
    }
    return () => {
      installSeriveRef?.current?.querySelectorAll("a").forEach(item => {
        item?.removeEventListener("click", servicesClick)
      })
    }
  }, [showAddanInstallCard, servicePrice])

  const storeclickHandler = (e, productInfo) => {
    const { target: { href = "", textContent = "" } = {} } = e
    addAnalyticsForStoreNearYou(textContent, href, productInfo)
    window.open(href)
  }

  useEffect(() => {
    if (utilityLocation) setZipCodeInputVal(utilityLocation)
  }, [utilityLocation])

  useEffect(() => {
    isInitionalRender.current = true
    if (!zipCodeInputVal)
      setZipCodeInputVal(localStorage?.getItem("currentZipCode"))
    // handleCheckAvailability(localStorage?.getItem("currentZipCode"), true)

    // fetchFindStoreUtilityDetails()
    if (learnMoreRef?.current) {
      learnMoreRef?.current?.querySelectorAll("a").forEach(item => {
        item?.addEventListener("click", e => {
          installserviceClickHandler(e, productInfo)
        })
      })
    }
    return () => {
      learnMoreRef?.current?.querySelectorAll("a").forEach(item => {
        item?.removeEventListener("click", e => {
          installserviceClickHandler(e, productInfo)
        })
      })
    }
  }, [])

  const fetchFindStoreUtilityDetails = () => {
    aemAxiosInstance({
      url: GLOBAL_CONFIGURATION_ENDPOINT,
      params: {
        path: findStoreDetailsUrl,
      },
    })
      .then(response => {
        const { data = {} } = response
        if (response && data) {
          setFindStoreUtilityDetails(data)
          // if (zipCodeInputVal && colorsData.length)
          // fetchProductsOnDisplayStores()
        }
      })
      .catch(err => {
        console.log("Failed to get compare attributes JSON file", err)
      })
  }

  const fetchProductsOnDisplayStores = async () => {
    const skus = colorsData?.map(item => item.id) ?? []
    const { data: { info = [] } = {} } = await getFindAStoresResult(
      findStores,
      zipCodeInputVal,
      brandName,
      null,
      1,
      "",
      null,
      skus.join(",")
    )
    if (info.length) setStoreInfo(info)
    else setStoreInfo([])
  }

  useEffect(() => {
    if (productServices.length) {
      const qualifiedService =
        installServices.find(item => item.sku === productServices[0]) ?? {}
      setServiceDetails(qualifiedService)
      if (installationData.length) {
        const qaulifiedServiceBusinessData =
          installationData.find(
            item => item.masterVariant.sku === productServices[0]
          ) ?? {}

        const { masterVariant: { prices = [] } = {} } =
          qaulifiedServiceBusinessData ?? {}

        if (prices.length) {
          const priceObj =
            prices.find(item => item.value.currencyCode === currencyCode) ?? {}
          const { value: { centAmount = "" } = {} } = priceObj
          const installationPrice = Number(centAmount / 100).toFixed(2)
          setServicePrice(installationPrice)
        }
      }
    }
  }, [productServices, installationData])

  // useEffect(() => {
  //   if (zipCodeInputVal && colorsData.length) fetchProductsOnDisplayStores()
  // }, [colorsData])
  useEffect(() => {
    getPincode().then(zip => setZipcode(zip))
  }, [])

  const handleFieldInfoMouseOver = (
    tooltipFor = "buyMoreSaveMore",
    value = false
  ) => {
    setTooltip({ ...tooltip, [tooltipFor]: value })
  }

  const handleAddToCart = e => {
    e.preventDefault()
    if (!productServices.length) return
    const item = {
      sku: productServices[0],
      quantity: 1,
      userZipCode: zipCodeInputVal,
      brand: brandName,
    }
    const { quantity } = item
    const itemCountMessage = `${quantity} `
    const ToasterMsg = `${itemCountMessage}`
    addToCartItem([
      {
        ...item,
        isBundle: false,
        backorder: false,
      },
    ]).then(response => {
      const body = {
        actions: response,
      }
      dispatch(addToCart(body))
        .unwrap()
        .then(res => {
          if (res) {
            if (isMobile) {
              dispatch(
                showToast({
                  message: ToasterMsg,
                  isVisible: true,
                })
              )
            } else {
              dispatch(showPreviewCart())
            }
          }
        })
    })
  }

  const getProsessionalClickHandler = (e, productInfo) => {
    const { target: { href = "", textContent = "" } = {} } = e
    addAnalyticsForGetProfessionalClick(textContent, href, productInfo)
    window.open(href)
  }

  const handlerForAddServiceClick = e => {
    handleAddToCart(e)
    addAnalyticsForAddService(
      addServiceToCart,
      productInfo,
      serviceDetails.sectionHeading,
      servicePrice,
      productServices[0]
    )
  }

  const handleChangeZip = () => {
    setToggleZipCodeSection(false)
    addAnalyticsForChangeZipCode(changeZipCode, productInfo, zipCodeInputVal)
  }

  const handleZipCodeCallBack = isZipAvaialbe => {
    setShowAddanInstallCard(isZipAvaialbe)
    setToggleZipCodeSection(true)
    if (!isInitionalRender.current) {
      addAnalyticsForUpdate(
        updateZipTitle,
        productInfo,
        zipCodeInputVal,
        isZipAvaialbe
      )
    }
  }

  const handleCheckAvailability = (zipcode, isInitialCall = false) => {
    if (!isInitialCall) localStorage.setItem("currentZipCode", zipCodeInputVal)
    const zipToPass = zipCodeInputVal || zipcode
    getZipCode(zipToPass, handleZipCodeCallBack)
    // if (zipToPass) {
    //   fetchProductsOnDisplayStores()
    // }
  }

  const [finalUrlStore, setFinalUrlStore] = useState()
  const [finalUrlPro, setFinalUrlPro] = useState()
  const [finalUrlBathroom, setFinalUrlBathroom] = useState()
  useEffect(() => {
    getShortenedUrl(pdpJson?.sectionHeadingProductNotAvailable).then(res =>
      setFinalUrlStore(res)
    )
    getShortenedUrl(pdpJson?.localProHeading).then(res => setFinalUrlPro(res))
    getShortenedUrl(pdpJson?.designServices[0]?.designPlanSectionHeading).then(
      res => setFinalUrlBathroom(res)
    )
  }, [pdpJson?.sectionHeadingProductNotAvailable])

  return (
    <div>
      {/* {isPromoAllowed() ? ( */}
      {/* {isDiscountCodeActive ? (
        <div className="productonDisplay" id="spendSaveDisplayDiv">
          <div className="left-side">{productDisplayTitle}</div>
          <div className="main-right">
            <div className="right-side"> */}
              {/* <div className="right-side__title">
                {finalUrlStore &&
                  htmlParser(finalUrlStore ? finalUrlStore : "")}
              </div> */}
              {/* <div className="right-side__address">
                <div>{htmlParser(pdpJson?.descriptionProductNotAvailable)}</div>
              </div> */}
            {/* </div>
          </div>
        </div>
      ) : null} */}
      {/* ) : null} */}

      {/* {multiDesignServices.map((item, index) => {
        const productTypeIndex = item.productType.findIndex(ele =>
          ele.includes(productType)
        )
        if (productTypeIndex > -1) {
          return (
            <div key={index} className="purchase-design" ref={learnMoreRef}>
              <div className="purchase-design__left-side">
                {item.designPlanTitle ? htmlParser(item.designPlanTitle) : null}
              </div>
              <div className="purchase-design__right-side">
                <div className="design-service">
                  {item.multiSectionHeadingDesign
                    ? htmlParser(item.multiSectionHeadingDesign)
                    : null}
                </div>
                <div className="expert-design">
                  {item.multiserviceDescription
                    ? htmlParser(item.multiserviceDescription)
                    : null}
                </div>
              </div>
            </div>
          )
        } else { */}

      <div className="purchase-design" ref={learnMoreRef}>
        <div className="purchase-design__left-side">
          {pdpJson?.designServices.length > 0 &&
            finalUrlBathroom &&
            htmlParser(pdpJson?.designServices[0]?.designPlanTitle)}
        </div>
        <div className="purchase-design__right-side">
          <div className="design-service">
            {pdpJson?.designServices.length > 0 &&
              finalUrlBathroom &&
              htmlParser(finalUrlBathroom ? finalUrlBathroom : "")}
          </div>
          <div className="expert-design">
            {pdpJson?.designServices.length > 0 &&
              htmlParser(pdpJson?.designServices[0]?.designPlanDescription)}
          </div>
        </div>
      </div>

      <div className="add-installation-noservice">
        <div className="noservice-title">{pdpJson?.localProTitle}</div>
        <div className="noservice__right-side">
          <div className="header">
            {finalUrlPro && htmlParser(finalUrlPro ? finalUrlPro : "")}
          </div>
          <div className="desc">{htmlParser(pdpJson?.serviceavailable)}</div>
        </div>
      </div>
      {/* }
      })} */}
    </div>
  )
}
export default ProductOnDisplay
